import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Theme,
  Card,
  Flex,
  Text,
  Link,
  Button,
  Separator,
} from "@radix-ui/themes";
import { FaLinkedin, FaGithub, FaTwitter, FaGlobe } from "react-icons/fa";
import Cal from "@calcom/embed-react";

function LightBreeze({ user }) {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <Theme appearance="light" accentColor="mint">
      <Helmet>
        <title>{user?.name} | Profiles</title>
        <meta
          name="description"
          content={`${user?.name}'s profile on Profiler. View links, bio, and schedule meetings.`}
        />
      </Helmet>
      <div style={{ background: "#f0fff4", minHeight: "100vh" }}>
        {!showCalendar ? (
          <Flex
            align="center"
            justify="center"
            style={{ height: "100vh", padding: "2rem" }}
          >
            <Card
              size="4"
              style={{
                maxWidth: "500px",
                width: "100%",
                borderRadius: "18px",
                background: "#ffffff",
                border: "1px solid #bfeadd",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.05)",
                padding: "2rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  background: "#e6fffa",
                  padding: "1rem",
                  borderRadius: "12px",
                  marginBottom: "1rem",
                }}
              >
                <Text size="5" weight="bold" color="mint">
                  {user.name}
                </Text>
                <Text color="gray">@{user.username}</Text>
              </div>

              <Text size="2" style={{ color: "#444" }}>
                {user.description}
              </Text>

              <Separator my="3" size="4" />

              <Flex gap="4" mt="1" align="center" wrap="wrap">
                {user.socialLinks?.linkedin && (
                  <Link
                    href={user.socialLinks.linkedin}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#444",
                    }}
                  >
                    <FaLinkedin /> LinkedIn
                  </Link>
                )}
                {user.socialLinks?.github && (
                  <Link
                    href={user.socialLinks.github}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#444",
                    }}
                  >
                    <FaGithub /> GitHub
                  </Link>
                )}
                {user.socialLinks?.twitter && (
                  <Link
                    href={user.socialLinks.twitter}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#444",
                    }}
                  >
                    <FaTwitter /> Twitter
                  </Link>
                )}
                {user.socialLinks?.website && (
                  <Link
                    href={user.socialLinks.website}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#444",
                    }}
                  >
                    <FaGlobe /> Website
                  </Link>
                )}
              </Flex>

              {user.calcomUsername && (
                <Flex justify="center">
                  <Button
                    mt="4"
                    variant="solid"
                    color="mint"
                    onClick={() => setShowCalendar(true)}
                  >
                    Schedule Meeting
                  </Button>
                </Flex>
              )}
            </Card>
          </Flex>
        ) : (
          <Flex
            justify="center"
            style={{
              animation: "fadeIn 400ms ease-in-out",
              paddingTop: "4rem",
            }}
          >
            <div style={{ width: "100%", overflow: "hidden" }}>
              <Cal calLink={`${user.calcomUsername}/15min`} />
            </div>
          </Flex>
        )}

        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
      </div>
    </Theme>
  );
}

export default LightBreeze;
